export default [
  {
    id: 1,
    title: '如何为帮助中心自定义域名获取 SSL 证书',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: '张明' },
    category: {
      slug: 'configuration',
      icon: '📦',
      name: '设置与配置',
    },
    views: 3400,
  },
  {
    id: 2,
    title: '设置您的第一个帮助中心门户',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: '李华' },
    category: { slug: 'onboarding', icon: '🧑‍🍳', name: '入门指南' },
    views: 400,
  },
  {
    id: 3,
    title: '组织帮助中心内容的最佳实践',
    status: 'archived',
    updatedAt: 1729205669,
    author: { availableName: '王芳' },
    category: { slug: 'best-practices', icon: '⛺️', name: '最佳实践' },
    views: 400,
  },
  {
    id: 4,
    title: '自定义帮助中心外观',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: '陈静' },
    category: { slug: 'design', icon: '🎨', name: '设计' },
    views: 400,
  },
  {
    id: 5,
    title: '将帮助中心与第三方工具集成',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: '刘洋' },
    category: {
      slug: 'integrations',
      icon: '🔗',
      name: '集成',
    },
    views: 2800,
  },
  {
    id: 6,
    title: '管理帮助中心用户权限',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: '赵磊' },
    category: {
      slug: 'administration',
      icon: '🔐',
      name: '管理',
    },
    views: 1200,
  },
  {
    id: 7,
    title: '创建和管理 FAQ 板块',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: '孙丽' },
    category: {
      slug: 'content-management',
      icon: '📝',
      name: '内容管理',
    },
    views: 5600,
  },
  {
    id: 8,
    title: '在帮助中心实现搜索功能',
    status: 'archived',
    updatedAt: 1729205669,
    author: { availableName: '周杰' },
    category: {
      slug: 'features',
      icon: '🔍',
      name: '功能',
    },
    views: 1800,
  },
  {
    id: 9,
    title: '分析帮助中心使用数据',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: '吴敏' },
    category: {
      slug: 'analytics',
      icon: '📊',
      name: '数据分析',
    },
    views: 3200,
  },
  {
    id: 10,
    title: '在帮助中心设置多语言支持',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: '郑强' },
    category: {
      slug: 'localization',
      icon: '🌍',
      name: '本地化',
    },
    views: 900,
  },
  {
    id: 11,
    title: '为产品创建互动教程',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: '黄婷' },
    category: {
      slug: 'education',
      icon: '🎓',
      name: '教程',
    },
    views: 4100,
  },
  {
    id: 12,
    title: '在帮助中心实现反馈系统',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: '林峰' },
    category: {
      slug: 'user-engagement',
      icon: '💬',
      name: '用户互动',
    },
    views: 750,
  },
  {
    id: 13,
    title: '优化帮助中心内容的 SEO',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: '徐娜' },
    category: {
      slug: 'seo',
      icon: '🚀',
      name: 'SEO',
    },
    views: 2900,
  },
  {
    id: 14,
    title: '为内部团队创建知识库',
    status: 'archived',
    updatedAt: 1729205669,
    author: { availableName: '何伟' },
    category: {
      slug: 'internal-resources',
      icon: '🏢',
      name: '内部资源',
    },
    views: 1500,
  },
];
